var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('campaign-action-center',{attrs:{"campaignId":_vm.id,"actionId":_vm.actionId}})}
var staticRenderFns = []

export { render, staticRenderFns }